import { Checkbox, Section } from '@web_opxp/components';
import { LanguageSelectors, StatsSelectors, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect, useSelector } from 'react-redux';
import { LED_CONSENT_STAT } from '../base/constants';
import { CyclesSelectors } from '../cycles';
import { IState } from '../store/state';
import { trackLedSettingAction } from './firebaseActions';
import './LEDSection.scss';
import { PersonalizationActions } from './slice';

interface ILEDSectionOwnProps {
  userId?: number;
}

export interface ILEDSectionProps extends ILEDSectionOwnProps {
  loaded: boolean;
  ledStat: boolean;
  onSaveLEDStat: typeof PersonalizationActions.savePersonalizationLEDStat;
  onTrackLEDSetting: typeof trackLedSettingAction;
}

export const LEDSectionFC: React.FC<ILEDSectionProps> = ({
  loaded,
  ledStat,
  onSaveLEDStat,
  onTrackLEDSetting,
  userId,
}) => {
  const { t } = useTranslation();
  const onCheckboxChange = (value: boolean) => {
    // see BW-7571
    // inverted boolean value true = 0, false = 1
    onSaveLEDStat(!value, userId);
    onTrackLEDSetting(!value);
  };
  const cyclesLoading = useSelector(CyclesSelectors.isCyclesLoading);
  const cyclesSaving = useSelector(CyclesSelectors.isCyclesSaving);
  const statsSaving = useSelector(StatsSelectors.isSaving);
  const workInProgress = cyclesLoading || cyclesSaving || statsSaving;
  return (
    <Section className="led-section">
      <div className="row">
        <div className="title col-4">
          <h3>{t('Personalization.LEDSection.Title')}</h3>
        </div>
        <div className="content col-8">
          <p>{t('Personalization.LEDSection.Description')}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-4" />
        <div className="col-8">
          <div className="row">
            {loaded && (
              <Checkbox
                className="checkboxContainer col-6"
                id="led-consent"
                key="led-consent"
                onChange={onCheckboxChange}
                disabled={workInProgress}
                checked={ledStat}>
                <span>{t(`Personalization.LEDSection.Consent`)}</span>
              </Checkbox>
            )}
          </div>
        </div>
      </div>
    </Section>
  );
};

export const mapStateToProps = (state: IState, { userId }: ILEDSectionOwnProps) => {
  const langLoaded = !LanguageSelectors.isLoading(state);
  const statsLoaded = !StatsSelectors.isStatsLoading(state);
  const loaded = statsLoaded && langLoaded;
  const ledStatIntValue = StatsSelectors.getStatIntValueById(state, LED_CONSENT_STAT, userId);
  // when stat is not set default value is "ON"
  // when stat is set 0 = activated
  const ledStat = typeof ledStatIntValue === 'undefined' ? true : ledStatIntValue === 0;
  return {
    loaded,
    ledStat,
  };
};

const mapDispatchToProps = {
  onSaveLEDStat: PersonalizationActions.savePersonalizationLEDStat,
  onTrackLEDSetting: trackLedSettingAction,
};

const LEDSection = connect(mapStateToProps, mapDispatchToProps)(LEDSectionFC);

export default LEDSection;
